export interface WorkerManifest {
  /**
   * name of the worker.
   */
  name: string;
}
